// extracted by mini-css-extract-plugin
export var auto = "_34-1";
export var spinner = "_34-0";